import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    path: '/tika-assistant/user-agreement',
    name: 'tikaAssistantUserAgreement',
    component: () =>
      import(
        /* webpackChunkName: "tikaAssistantUserAgreement" */ '@/views/tika-assistant/agreements/UserAgreement.vue'
      ),
    meta: {
      cname: '安装小助手用户服务协议'
    }
  },
  {
    path: '/tika-assistant/privacy-policy',
    name: 'tikaAssistantPrivacyPolicy',
    component: () =>
      import(
        /* webpackChunkName: "tikaAssistantPrivacyPolicy" */ '@/views/tika-assistant/agreements/PrivacyPolicy.vue'
      ),
    meta: {
      cname: '安装小助手隐私保护政策'
    }
  }
];

export default routes;
